import classNames from "classnames";
import CiroButton, { CiroButtonStyleEnum } from "../../../shared/CiroButton";
import { gql } from "@apollo/client";
import { AutopilotSessionWebhookExportModalError_ExportToWebhookTransactionStatusFragment } from "../../../../__generated__/graphql";

export const AutopilotSessionWebhookExportModalError_ExportToWebhookTransactionStatus = gql`
  fragment AutopilotSessionWebhookExportModalError_ExportToWebhookTransactionStatus on ExportToWebhookTransactionStatusResponse {
    errorMessage
  }
`;

interface IAutopilotSessionWebhookExportModalErrorProps {
  exportToWebhookTransactionStatus:
    | AutopilotSessionWebhookExportModalError_ExportToWebhookTransactionStatusFragment
    | undefined;
  onRetry: () => void;
  onClose: () => void;
}

const AutopilotSessionWebhookExportModalError = ({
  exportToWebhookTransactionStatus,
  onRetry,
  onClose,
}: IAutopilotSessionWebhookExportModalErrorProps) => {
  return (
    <>
      <div className={classNames("sm:flex", "sm:items-start")}>
        <div
          className={classNames(
            "mt-3",
            "text-center",
            "sm:mt-0",
            "sm:text-left",
            "w-full",
          )}
        >
          <h3
            className={classNames(
              "text-lg",
              "font-medium",
              "leading-6",
              "text-red-900",
              "mb-4",
            )}
          >
            Export failed
          </h3>

          <div
            className={classNames(
              "bg-red-50",
              "border",
              "border-red-200",
              "rounded-md",
              "p-4",
            )}
          >
            <div className={classNames("flex")}>
              <p className={classNames("mt-2", "text-sm", "text-red-700")}>
                {exportToWebhookTransactionStatus?.errorMessage ||
                  "An error occurred while exporting to webhook"}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className={classNames(
          "mt-5",
          "sm:mt-4",
          "sm:flex",
          "sm:flex-row-reverse",
        )}
      >
        <CiroButton
          analyticsField="Retry Webhook Export"
          onClick={onRetry}
          customClassName={classNames("w-full", "sm:w-auto", "sm:ml-3")}
        >
          Try Again
        </CiroButton>
        <CiroButton
          analyticsField="Close Webhook Export Error"
          style={CiroButtonStyleEnum.SECONDARY}
          onClick={onClose}
          customClassName={classNames("mt-3", "w-full", "sm:mt-0", "sm:w-auto")}
        >
          Close
        </CiroButton>
      </div>
    </>
  );
};

export default AutopilotSessionWebhookExportModalError;
